import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { View } from "react-native";
import { useTranslation } from "react-i18next";
import Charting from "../../../Components/Charting";
import Constants from "../../../Constants";
import DashboardItem from "./DashboardItem";
import DashboardPlaceholder from "./DashboardPlaceholder";

// Per-day training consumption tile. Lives at the very BOTTOM of the Usage
// tab (below the per-user card) — extracted from CostingView so the tab order
// can put the Consumption-by-user card above it.
const TrainingConsumptionView = ({
  consumptionAPIInProgress,
  isParseCost,
  normalisedTrainingConsumption,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();

  const stringToColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      let value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
  };

  return (
    <View style={{ marginTop: 5, alignItems: "center" }}>
      <DashboardItem
        isFetchInProgress={consumptionAPIInProgress}
        title={t("dashboard.costingView.trainingCost")}
        isHalfWidth={false}
      >
        {isParseCost &&
        normalisedTrainingConsumption?.datasets?.length > 0 ? (
          <Charting.AppBarChart
            maxHeight={Constants.chartMaxHeight}
            options={{
              legend: {
                position: "bottom",
                display: true,
                labels: {
                  color: currentTheme?.theme?.font_color,
                  font: {
                    family: "normalFont",
                    size: currentTheme?.theme?.extra_small_font_size,
                  },
                },
              },
              scales: {
                x: {
                  stacked: true,
                  grid: { display: false },
                  ticks: {
                    color: currentTheme?.theme?.font_color,
                    font: {
                      size: currentTheme?.theme?.extra_small_font_size,
                    },
                  },
                },
                y: {
                  type: "linear",
                  stacked: true,
                  display: true,
                  position: "left",
                  ticks: {
                    color: currentTheme?.theme?.font_color,
                    font: {
                      size: currentTheme?.theme?.extra_small_font_size,
                    },
                  },
                },
              },
            }}
            dataset={{
              labels: normalisedTrainingConsumption?.labels,
              datasets: [
                ...normalisedTrainingConsumption?.datasets?.map((u) => ({
                  label: u.label,
                  data: u.data,
                  borderColor: stringToColor(u.label),
                  borderRadius: 10,
                  backgroundColor: stringToColor(u.label),
                  yAxisID: "y",
                })),
              ],
            }}
          />
        ) : (
          <DashboardPlaceholder
            mainCaption={t("dashboard.costingView.emptyPlaceholder")}
            subCaption={t("dashboard.costingView.runFirstTraining")}
          />
        )}
      </DashboardItem>
    </View>
  );
};

export default TrainingConsumptionView;
